module.exports = __webpack_public_path__ + "static/media/SarahSwitek_01_Introduction_2.973dc4a4.mp3";